import { render, staticRenderFns } from "./BannerComputacion.vue?vue&type=template&id=4ee50249&scoped=true"
import script from "./BannerComputacion.vue?vue&type=script&lang=js"
export * from "./BannerComputacion.vue?vue&type=script&lang=js"
import style0 from "./BannerComputacion.vue?vue&type=style&index=0&id=4ee50249&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee50249",
  null
  
)

export default component.exports